import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import {
  FiArrowLeft,
  FiMapPin,
  FiCalendar,
  FiCheckCircle,
  FiTrendingUp,
  FiUsers,
  FiClock,
  FiTarget
} from 'react-icons/fi';
import RmbIcon from '../../components/RmbIcon';
import './ProjectDetail.css';

const ProjectDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // 项目数据（与Projects页面同步）
  const projectsData = {
    1: {
      title: '宁波国际科创中心 · 全过程造价治理',
      type: '工程造价',
      industry: '科技园区',
      location: '宁波 · 高新区',
      date: '2024年',
      budget: '28亿',
      duration: '36个月',
      client: '宁波高新区管委会',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&q=85&fm=webp',
      summary: '项目包含科研办公、实验中心、公共配套三大功能组团，总建筑面积约35万平方米。识道造价为本项目提供从投资决策到竣工结算的全过程造价咨询服务。',
      challenge: [
        '多功能组团、多专业协同，造价管理复杂度高',
        '建设周期长，材料价格波动风险大',
        '创新型科研设施较多，缺乏可参考的造价指标',
        '业主方要求精细化成本管控与实时数据监控'
      ],
      solution: [
        '建立"目标成本-合同成本-实际成本"三算对比模型',
        '采用 BIM+造价一体化平台，实现设计变更实时联动',
        '引入 AI 审核引擎，对变更签证进行智能预审',
        '搭建动态成本监控看板，每周输出成本分析报告'
      ],
      results: [
        '动态成本偏差控制在 3% 以内，审减金额 2.6 亿元',
        '建立"目标成本-合同成本-实际成本"三算对比模型并可视化展示',
        '通过 AI 识别并纠偏 72 项变更签证，项目提前 25 天竣工',
        '沉淀科技园区造价指标库，为后续同类项目提供数据支撑'
      ],
      teamSize: '8人专项团队',
      serviceScope: '投资估算、限额设计、动态成本控制、结算审核、后评价',
      deliverables: [
        '投资估算报告',
        '设计概算书',
        '施工图预算及工程量清单',
        '月度成本分析报告（共36期）',
        '竣工结算审核报告',
        '项目后评价与造价指标库'
      ]
    },
    2: {
      title: '宁波轨道交通枢纽中心 · 概预算结算审计',
      type: '概预算审核',
      industry: '交通基建',
      location: '宁波 · 鄞州区',
      date: '2023年',
      budget: '45亿',
      duration: '48个月',
      client: '宁波市轨道交通集团',
      image: 'https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=1200&q=85&fm=webp',
      summary: '集轨道交通、综合交通换乘、商业配套于一体的大型枢纽工程，地下四层、地上六层，总建筑面积约28万平方米。识道为财政审计部门提供概算、预算、结算全流程审计服务。',
      challenge: [
        '工程体量大、专业多，审计工作量巨大',
        '涉及财政、审计、国资等多部门联合审查',
        '工期紧张，要求快速出具审计结论',
        '需符合审计署、财政部相关规范要求'
      ],
      solution: [
        '采用 AI 智能审核引擎进行概预算快速预审',
        '组建 12 人专家审核团队，分专业并行审核',
        '建立"问题清单-整改追踪-复核验收"闭环管理',
        '形成标准化审计底稿，满足多部门审查要求'
      ],
      results: [
        'AI+专家双审识别成本偏差事项 134 项，审减金额 5.8 亿元',
        '形成 1800+ 页审计底稿与整改清单，满足财政审计一体化要求',
        '审核效率较传统模式提升 60%，通过财政、审计"联合验收"',
        '为宁波市其他轨道交通项目提供造价参考数据'
      ],
      teamSize: '12人审核团队',
      serviceScope: '概算审核、预算审核、结算审核、审计配合',
      deliverables: [
        '概算审核报告',
        '预算审核报告',
        '结算审核报告（含审减明细）',
        '问题清单与整改追踪表',
        '审计底稿（1800+页）',
        '造价指标数据库'
      ]
    },
    3: {
      title: '宁波智慧制造产业园 · 电子化招投标',
      type: '招投标',
      industry: '工业制造',
      location: '浙江 · 宁波',
      date: '2024年',
      budget: '36亿',
      duration: '24个月',
      client: '宁波经济技术开发区',
      image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1200&q=85&fm=webp',
      summary: '项目建设智能制造厂房、研发孵化中心、配套公建等，涉及9大专业32个子项目。识道承担 EPC 总承包及专业分包招标代理，全流程电子化留痕。',
      challenge: [
        '多标段、多专业招标，协调难度大',
        '工艺设备招标技术门槛高，评标专业性要求强',
        '工期紧，要求快速完成招标工作',
        '需满足国有资产交易监管及审计要求'
      ],
      solution: [
        '搭建电子化招投标管理平台，实现全程线上操作',
        '制定"技术标+方案标+商务标"综合评审模型',
        '邀请行业专家参与评标，确保技术方案可行性',
        '全流程留痕，形成完整的招标档案资料'
      ],
      results: [
        '覆盖 9 大专业 32 个子项目招标，参与投标单位 120+',
        '采用"技术标+方案标+商务标"综合评审模型，中标价较控制价降低 11.8%',
        '招标过程合规率 100%，留痕材料一次性通过审计',
        '电子化招投标平台获得业主方高度认可，后续推广至其他项目'
      ],
      teamSize: '6人招标团队',
      serviceScope: '招标策略、文件编制、公告发布、评标组织、中标公示',
      deliverables: [
        '招标文件（含技术规范、商务条款、评标办法）',
        '资格预审文件',
        '评标报告（32份）',
        '中标通知书',
        '招标过程全程留痕资料',
        '电子化招投标平台使用手册'
      ]
    },
    4: {
      title: '浙江智慧医院集群 · BIM+造价一体化',
      type: '工程造价',
      industry: '医疗健康',
      location: '宁波 · 杭州 · 温州',
      date: '2023年',
      budget: '18亿',
      duration: '30个月',
      client: '浙江省卫健委 / 地方卫健局',
      image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1200&q=85&fm=webp',
      summary: '三座三甲综合医院同步建设，采用 BIM 正向设计+造价一体化模式，实现设计、造价、施工多专业协同，形成标准化造价数据库。',
      challenge: [
        '三座医院同步建设，造价管理需统一标准',
        '医疗工艺复杂，机电设备占比高',
        '设计变更频繁，传统算量模式效率低',
        '业主要求沉淀造价指标，为后续项目提供参考'
      ],
      solution: [
        '基于 Revit 模型建立 BIM+造价一体化工作流',
        '设计变更自动联动造价数据，实时更新成本',
        '建立医疗建筑造价标准库（机电、装饰、专项设备）',
        '通过三个项目的数据沉淀，形成集团造价指标体系'
      ],
      results: [
        'BIM 直接出量覆盖率提升至 92%，设计变更联动时间缩短 70%',
        '沉淀 600+ 项材料设备价格，建立集团造价指标库',
        '项目整体投资控制率 15%，建设周期缩短 3 个月',
        '为浙江省其他医院建设项目提供造价对标数据'
      ],
      teamSize: '10人 BIM+造价团队',
      serviceScope: 'BIM建模、造价一体化算量、动态成本控制、指标库建设',
      deliverables: [
        'BIM 模型（建筑、结构、机电）',
        '基于 BIM 的工程量清单',
        '设计变更造价影响分析报告',
        '月度成本监控报告',
        '医疗建筑造价指标库',
        '竣工结算报告'
      ]
    },
    5: {
      title: '西部新能源基地 · 造价审计与投融资决策',
      type: '概预算审核',
      industry: '新能源',
      location: '甘肃 · 酒泉',
      date: '2022年',
      budget: '52亿',
      duration: '18个月',
      client: '某央企新能源集团',
      image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1200&q=85&fm=webp',
      summary: '风光储一体化新能源基地项目，包含光伏发电、风力发电、储能系统及配套设施。识道为国有资本提供 EPC 合同审核、设备采购审计、投融资决策支持。',
      challenge: [
        '新能源项目造价构成特殊，设备占比高达60%',
        '国际设备采购，价格波动风险大',
        'EPC 合同条款复杂，需精准把控合同风险',
        '项目涉及多轮融资，需提供投资决策数据支撑'
      ],
      solution: [
        '建立新能源项目造价数据库，对标国内外同类项目',
        '对设备采购合同进行逐项审核，识别价格异常',
        '引入投融资模型，测算项目 IRR、NPV 等财务指标',
        '提供分阶段资金计划与成本预警机制'
      ],
      results: [
        '审计金额 52 亿元，识别材料采购异常 36 项，优化资金计划 12%',
        '形成新能源行业造价指标模型，为后续 8 个项目提供参考',
        '通过能源、水利、财政三部门联合审查',
        '为集团投资决策提供详实的财务测算与风险分析'
      ],
      teamSize: '5人审计团队',
      serviceScope: 'EPC合同审核、设备采购审计、投融资决策支持、造价指标建设',
      deliverables: [
        'EPC 合同审核报告',
        '设备采购审计报告',
        '投融资测算模型',
        '资金计划与现金流预测',
        '新能源造价指标库',
        '审计底稿与问题清单'
      ]
    },
    6: {
      title: '宁波轨道 TOD 综合开发 · 招投标 + 造价一体化',
      type: '招投标',
      industry: 'TOD 综合体',
      location: '宁波 · 北仑区',
      date: '2022年',
      budget: '40亿',
      duration: '42个月',
      client: '宁波轨道交通集团 / 某地产开发商',
      image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1200&q=85&fm=webp',
      summary: '轨道交通上盖 TOD 综合体开发项目，包含住宅、商业、办公等多种业态。识道提供招投标组织、投标咨询及全过程造价服务。',
      challenge: [
        'TOD 项目涉及轨道+物业双主体，协调复杂',
        '商业业态组合多样，需平衡投资收益与建设成本',
        '招投标需兼顾工程质量与投资控制',
        '项目 IRR 要求高，需精细化成本测算'
      ],
      solution: [
        '建立业态组合与投资收益模型，优化商业配比',
        '招标阶段引入全过程造价咨询单位，形成一体化服务',
        '采用电子化招投标平台，全程留痕可追溯',
        '动态测算不同业态组合下的项目 IRR 与 NPV'
      ],
      results: [
        '招投标全程电子化，资料留痕 100%',
        '协助开发商优化商业组合与投资收益模型',
        '项目整体 IRR 提升 2.6%，通过集团投资决策会审',
        '中标施工单位在造价、质量、工期三方面综合最优'
      ],
      teamSize: '7人联合团队（招标+造价）',
      serviceScope: '招标代理、投标咨询、全过程造价、投资收益测算',
      deliverables: [
        '招标文件与评标报告',
        '投资收益测算模型',
        '业态组合优化方案',
        '全过程造价咨询报告',
        '竣工结算报告',
        '项目后评价'
      ]
    }
  };

  const project = projectsData[id];

  if (!project) {
    return (
      <main className="project-detail-page">
        <div className="container" style={{ padding: '120px 0', textAlign: 'center' }}>
          <h2>项目未找到</h2>
          <Link to="/projects" className="btn btn-primary" style={{ marginTop: '20px' }}>返回案例列表</Link>
        </div>
      </main>
    );
  }

  return (
    <main className="project-detail-page">
      <section className="detail-hero" style={{ backgroundImage: `url(${project.image})` }}>
        <div className="hero-overlay" />
        <div className="container">
          <button className="back-btn" onClick={() => navigate('/projects')}>
            <FiArrowLeft />
            <span>返回案例列表</span>
          </button>
          <div className="hero-content">
            <div className="project-badge">{project.type}</div>
            <h1>{project.title}</h1>
            <div className="project-meta-hero">
              <span><FiMapPin /> {project.location}</span>
              <span><FiCalendar /> {project.date}</span>
              <span><RmbIcon size={16} /> 总投资 {project.budget}</span>
              <span><FiClock /> 建设周期 {project.duration}</span>
            </div>
          </div>
        </div>
      </section>

      <section className="detail-content">
        <div className="container">
          <div className="content-grid">
            <div className="main-content">
              <div className="content-block">
                <h2>项目概况</h2>
                <p>{project.summary}</p>
              </div>

              <div className="content-block">
                <h2>项目挑战</h2>
                <ul className="challenge-list">
                  {project.challenge.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="content-block">
                <h2>识道方案</h2>
                <div className="solution-grid">
                  {project.solution.map((item, index) => (
                    <div key={index} className="solution-item">
                      <div className="solution-number">0{index + 1}</div>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="content-block">
                <h2>项目成果</h2>
                <div className="results-grid">
                  {project.results.map((item, index) => (
                    <div key={index} className="result-card">
                      <FiCheckCircle />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="content-block">
                <h2>交付成果</h2>
                <div className="deliverables-list">
                  {project.deliverables.map((item, index) => (
                    <div key={index} className="deliverable-item">
                      <FiCheckCircle />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <aside className="sidebar">
              <div className="info-card">
                <h3>项目信息</h3>
                <div className="info-list">
                  <div className="info-item">
                    <span className="label">项目类型</span>
                    <span className="value">{project.type}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">所属行业</span>
                    <span className="value">{project.industry}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">项目地点</span>
                    <span className="value">{project.location}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">完成时间</span>
                    <span className="value">{project.date}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">总投资</span>
                    <span className="value">{project.budget}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">建设周期</span>
                    <span className="value">{project.duration}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">委托单位</span>
                    <span className="value">{project.client}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">服务团队</span>
                    <span className="value">{project.teamSize}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">服务范围</span>
                    <span className="value">{project.serviceScope}</span>
                  </div>
                </div>
              </div>

              <div className="cta-card-sidebar">
                <FiTarget className="cta-icon" />
                <h4>需要类似服务？</h4>
                <p>我们为类似项目提供专业咨询与数据支持</p>
                <Link to="/contact" className="btn btn-primary">
                  立即咨询
                </Link>
                <Link to="/projects" className="btn btn-secondary">
                  查看更多案例
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProjectDetail;



